<template>
  <section class="actions-block">
    <ul class="actions-list">
      <!-- Bloc Gestionnaire -->
      <li class="action-item">
        <router-link :to="{ name: 'GestionnairePage2' }" class="action-card action-card--gestionnaire">
          <div class="action-card__badge">
            Mairies · Services enfance · Gestionnaires · Directeur de restauration collective
          </div>
          <div class="action-card__icon-wrap">
            <v-img
              src="/static/images/doodles-dsfr/secondary/SprintingDoodle.png"
              v-if="$vuetify.breakpoint.smAndUp"
              class="action-card__doodle"
              contain
              max-height="110"
            />
          </div>
          <div class="action-card__body">
            <h2 class="action-card__title">Espace Gestionnaire</h2>
            <p class="action-card__desc">
              Pilotez votre restauration collective, réduisez le gaspillage alimentaire et démontrez votre conformité
              EGAlim — en 3 clics par service.
            </p>
            <ul class="action-card__features">
              <li>✓ Suivi des absences & effectifs en temps réel</li>
              <li>✓ Gestion des surplus & dons aux associations</li>
              <li>✓ Tableaux de bord conformité EGAlim</li>
            </ul>
          </div>
          <div class="action-card__cta">
            Découvrir l'espace
            <span class="action-card__arrow">→</span>
          </div>
        </router-link>
      </li>

      <!-- Bloc Nutritionniste -->
      <li class="action-item">
        <router-link :to="{ name: 'NutritionistePage2' }" class="action-card action-card--nutritionniste">
          <div class="action-card__badge">Diététiciens · Cuisines centrales · Cuisines concédées ou directes</div>
          <div class="action-card__icon-wrap">
            <v-img
              src="/static/images/doodles-dsfr/secondary/SitReadingDoodle.png"
              v-if="$vuetify.breakpoint.smAndUp"
              class="action-card__doodle"
              contain
              max-height="110"
            />
          </div>
          <div class="action-card__body">
            <h2 class="action-card__title">Espace Nutrition</h2>
            <p class="action-card__desc">
              Recevez les retours terrain en temps réel, ajustez vos menus et pilotez vos objectifs nutritionnels et
              anti-gaspillage à l'échelle de votre réseau.
            </p>
            <ul class="action-card__features">
              <li>✓ Feedback plat par plat automatisé</li>
              <li>✓ Détection prédictive des troubles alimentaires</li>
              <li>✓ Statistiques réseau multi-établissements</li>
            </ul>
          </div>
          <div class="action-card__cta">
            Découvrir l'espace
            <span class="action-card__arrow">→</span>
          </div>
        </router-link>
      </li>

      <!-- Bloc Convive -->
      <li class="action-item">
        <router-link :to="{ name: 'ConvivePage2' }" class="action-card action-card--convive">
          <div class="action-card__badge">Élèves · Chef de salle · Agent de restauration · Animateurs · Familles</div>
          <div class="action-card__icon-wrap">
            <v-img
              src="/static/images/doodles-dsfr/secondary/DogDoodle.png"
              v-if="$vuetify.breakpoint.smAndUp"
              class="action-card__doodle"
              contain
              max-height="110"
            />
          </div>
          <div class="action-card__body">
            <h2 class="action-card__title">Espace Convive</h2>
            <p class="action-card__desc">
              Votez sur les repas en 2 clics, participez aux défis anti-gaspillage et devenez acteur du bien-manger avec
              Labrigame.
            </p>
            <ul class="action-card__features">
              <li>✓ Vote numérique enfants en temps réel</li>
              <li>✓ Labrigame : défis & récompenses</li>
              <li>✓ Sensibilisation ludique au gaspillage</li>
            </ul>
          </div>
          <div class="action-card__cta">
            Découvrir l'espace
            <span class="action-card__arrow">→</span>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "ActionsBlock2",
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
}
</script>

<style scoped>
.actions-block {
  padding: 0;
}

.actions-list {
  display: flex;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
}

.action-item {
  flex: 1 1 280px;
  min-width: 0;
}

/* Base card */
.action-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 16px;
  padding: 24px;
  text-decoration: none;
  color: inherit;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  border: 2px solid transparent;
}

.action-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.12);
}

/* Gestionnaire — fond crème chaud, accent rouge Labricot */
.action-card--gestionnaire {
  background: linear-gradient(145deg, #fff8f5 0%, #fff3ee 100%);
  border-color: #f4c5b0;
}
.action-card--gestionnaire:hover {
  border-color: #e05a2b;
}
.action-card--gestionnaire .action-card__badge {
  background: #fde8da;
  color: #c94b1a;
}
.action-card--gestionnaire .action-card__cta {
  color: #e05a2b;
  border-top: 1px solid #f4c5b0;
}
.action-card--gestionnaire .action-card__features li::marker {
  color: #e05a2b;
}

/* Nutritionniste — fond vert très doux */
.action-card--nutritionniste {
  background: linear-gradient(145deg, #f3fbf6 0%, #edf7f1 100%);
  border-color: #a8d9bc;
}
.action-card--nutritionniste:hover {
  border-color: #2d9e5f;
}
.action-card--nutritionniste .action-card__badge {
  background: #d4f0e2;
  color: #1d7a47;
}
.action-card--nutritionniste .action-card__cta {
  color: #2d9e5f;
  border-top: 1px solid #a8d9bc;
}

/* Convive — fond bleu-lavande très léger */
.action-card--convive {
  background: linear-gradient(145deg, #f5f3ff 0%, #ede9ff 100%);
  border-color: #c4b8f5;
}
.action-card--convive:hover {
  border-color: #6c4de0;
}
.action-card--convive .action-card__badge {
  background: #e4dfff;
  color: #5539cc;
}
.action-card--convive .action-card__cta {
  color: #6c4de0;
  border-top: 1px solid #c4b8f5;
}

/* Badge public cible */
.action-card__badge {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
  margin-bottom: 12px;
  align-self: flex-start;
}

.action-card__icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.action-card__doodle {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08));
}

.action-card__body {
  flex: 1;
}

.action-card__title {
  font-size: 1.2rem;
  font-weight: 800;
  margin-bottom: 8px;
  color: #1a1a2e;
}

.action-card__desc {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #444;
  margin-bottom: 14px;
}

.action-card__features {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  font-size: 0.8rem;
  color: #555;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.action-card__cta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 14px;
  margin-top: 8px;
  font-weight: 700;
  font-size: 0.875rem;
}

.action-card__arrow {
  font-size: 1.1rem;
  transition: transform 0.2s ease;
}

.action-card:hover .action-card__arrow {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .actions-list {
    flex-direction: column;
  }
  .action-item {
    flex: 1 1 auto;
  }
}
</style>
